import { EnvironmentConfig } from '../../../../environment-config';
import { PublicOfferAppliedJobOrdersQuery } from '../../../../hooks/api/publicOfferAppliedJobOrders/publicOfferAppliedJobOrders.generated';

export const calculatePublicOfferAppliedVisibleOffersNumber = (
  publicOfferAppliedJobOrders: PublicOfferAppliedJobOrdersQuery['publicOfferAppliedJobOrders'],
) => {
  let visibleJobOrders = 1;

  const jobOrdersToApply = publicOfferAppliedJobOrders.filter(
    ({ score }) => score.finalScore >= EnvironmentConfig.minimalScoreToApply,
  );

  if (jobOrdersToApply.length) {
    visibleJobOrders = jobOrdersToApply.length;
  }

  return Math.min(5, visibleJobOrders);
};
